import { api } from '../../../plugins/axios';

export default class ShippingFeesRule {
	id = undefined;
	pickupLocation = undefined;
	locationGroups = [];
	/**
     * range schema
     *                  id: number
     *                  isLocal: boolean,
						from: number,
						to: number,
						price: number,
     */
	ranges = [];
	feesPerExtraKg = 0;
	isLocal = false;
	isDefault = false;

	constructor(obj) {
		Object.keys(obj).forEach((key) => {
			this[key] = obj[key];
		});
	}

	static fetchRules = async (params = {}) => {
		try {
			const { data: responseData } = await api.get('/shipping/shipping-groups', {
				params,
			});

			const data = responseData.result.shippingGroups.data;

			let defaultRule = new ShippingFeesRule({
				id: `rule-${Math.random()}`,
				ranges: [
					{
						id: `range-${Math.random()}`,
						isLocal: true,
						from: 0,
						to: '',
						price: '',
					},
				],
				isLocal: true,
				isDefault: true,
			});
			if (responseData.result.DefaultGroup) {
				const obj = responseData.result.DefaultGroup;
				defaultRule = new ShippingFeesRule({
					id: obj.id,
					ranges: obj.shipping_rates
						.map((range) => ({
							id: range.id,
							from: range.from_weight,
							to: range.to_weight,
							price: range.price,
						}))
						.sort((a, b) => +a.from - +b.from),
					feesPerExtraKg: obj.fees_per_extra_kg,
					isDefault: true,
				});
			}

			return {
				data: data.map((obj) => {
					return new ShippingFeesRule({
						id: obj.id,
						pickupLocation: obj.pickup_location,
						locationGroups: obj.regions,
						ranges: obj.shipping_rates
							.map((range) => ({
								id: range.id,
								from: range.from_weight,
								to: range.to_weight,
								price: range.price,
							}))
							.sort((a, b) => +a.from - +b.from),
						feesPerExtraKg: obj.fees_per_extra_kg,
					});
				}),
				totalRecords: responseData.result.shippingGroups.total,
				defaultRule,
			};
		} catch (e) {
			console.log(e);
		}
	};

	static async fetchFeesPolicy() {
		const res = await api.get('/settings/get-fee-Policy');
		const data = res.data.result;
		return data.fee_duplication_policy;
	}

	static async updateFeesPolicy(policy) {
		return api.post('/settings/manage-fee-Policy', { fee_duplication_policy: policy });
	}

	async create() {
		const data = await api.post(`/shipping/shipping-groups`, {
			name: '-',
			pickup_location_id: this.pickupLocation?.id,
			fees_per_extra_kg: this.feesPerExtraKg,
			regions_id: this.locationGroups.map((group) => group.id),
			shipping_rates: this.ranges.map((range) => ({
				from_weight: range.from,
				to_weight: range.to,
				price: range.price,
			})),
			is_default: this.isDefault,
		});
		if (!this.isDefault) {
			this.id = data.data.result.ShippingGroup.id;
			this.isLocal = false;
		}
	}

	async update() {
		await api.put(`/shipping/shipping-groups/${this.id}`, {
			name: '-',
			pickup_location_id: this.pickupLocation?.id,
			fees_per_extra_kg: this.feesPerExtraKg,
			regions_id: this.locationGroups.map((group) => group.id),
			shipping_rates: this.ranges.map((range) => ({
				from_weight: range.from,
				to_weight: range.to,
				price: range.price,
			})),
			is_default: this.isDefault,
		});
	}

	async save() {
		if (!this.isLocal) {
			await this.update();
		} else {
			await this.create();
		}
	}

	remove() {
		if (this.isLocal) return;
		return api.delete(`/shipping/shipping-groups/${this.id}`);
	}

	addNewRang() {
		const lastRange = this.ranges[this.ranges.length - 1];
		this.ranges.push({
			id: `range-${Math.random()}`,
			isLocal: true,
			from: lastRange.to,
			to: '',
			price: '',
		});
	}

	removeRange(idx) {
		this.ranges.splice(idx, 1);
		this.maintainRangesValues();
	}

	maintainRangesValues() {
		for (let i = 0; i < this.ranges.length - 1; i++) {
			if (this.ranges[i].to <= this.ranges[i].from) {
				this.ranges[i].to = this.ranges[i].from + 1;
			}
			const toVal = this.ranges[i].to;
			this.ranges[i + 1].from = toVal;
		}
	}
}
